<template>
    <div class="map-menu-container" ref="container">
        <div class="menu-heading" :class="show ? 'open' : ''">
            <div id="menu-toggler" class="menu-toggler" @click="toggleMenu">
                <span></span>
            </div>
            <a :href="homeUrl" class="logo">
                <inline-svg name="map/hac-logo-white"></inline-svg>
            </a>
        </div>
        <div class="map-menu" :class="!show ? 'mobile-hide' : ''">
            <div class="menu-container">
                <ul>
                    <li
                        is="menu-item"
                        :item="item"
                        v-for="(item, index) in items"
                        :key="index"
                        :getDropdown="getDropdown"
                    ></li>
                </ul>
                <div class="filter-clear">
                    <div class="menu-item" @click="clearFilters">
                        <a href="javascript:;" class="menu-link">
                            <inline-svg
                                name="map/trash"
                                width="15"
                                classes="menu-link__icon"
                            ></inline-svg>
                            <span class="menu-link__text">{{
                                "map.clear_all" | trans
                            }}</span>
                        </a>
                    </div>
                </div>
                <div class="language-selection" v-if="locales.length">
                    <div class="menu-item">
                        <div href="javascript:;" class="menu-link">
                            <inline-svg
                                name="map/network"
                                width="15"
                                height="15"
                                classes="menu-link__icon"
                            ></inline-svg>
                            <a
                                v-for="locale in locales"
                                :key="locale.code"
                                :href="locale.url"
                                class="language-link"
                                :class="
                                    currentLocale === locale.code
                                        ? 'active'
                                        : ''
                                "
                                >{{ locale.name }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="menu-copyright">
                <a href="javascript:;" class="menu-link">
                    © Hrvatske autoceste {{ new Date().getFullYear() }}.
                    <span>{{ "map.menu_footer" | trans }}</span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import menuItem from "./MenuItem.vue";
import inlineSvg from "./inlineSvg.js";
import menuItems from "./MapMenuItems.js";
import { mapGetters } from "vuex";
import axios from "./axios.js";

export default {
    name: "MapMenu",
    props: {
        homeUrl: {
            type: String,
            default: "/",
        },
        locales: {
            default: () => {},
        },
    },
    components: {
        inlineSvg,
        menuItem,
    },
    data() {
        return {
            items: menuItems,
            requested: false,
            show: false,
        };
    },
    mounted() {
        if (!this.url) {
            this.$store.commit("setUrl", `${this.homeUrl}/api/maps`);
        }

        this.getDropdown();
    },
    methods: {
        toggleMenu() {
            this.show = !this.show;
            if (this.show) {
                this.$store.commit("setModal", null);
                this.$refs.container.style.height = "100%";
            } else {
                this.$refs.container.style.height = "auto";
            }
        },
        clearFilters() {
            this.$store.commit("clearAllFilters");
            this.$store.commit("setModal", null);
        },
        getDropdown() {
            if (!Object.keys(this.codebook).length) {
                let response = {};
                let url = this.url ? `${this.url}/codebooks` : this.url;
                this.requested = true;

                axios
                    .get(url)
                    .then((res) => {
                        let keys = Object.keys(res.data);
                        keys.forEach((key) => {
                            let name;
                            if (key === "listHighways") {
                                name = "highways";
                            } else if (key === "listTollPlaces") {
                                name = "tollStations";
                            } else {
                                name = key;
                            }
                            response[name] = {
                                data: res.data[key],
                            };
                        });
                        this.$store.commit("setCodeBook", response);
                    })
                    .catch(function (error) {
                        this.requested = false;
                        console.log(error);
                    });
            }
        },
    },

    computed: {
        ...mapGetters([
            "highways",
            "filters",
            "restAreas",
            "url",
            "objects",
            "codebook",
            "modal",
            "markers",
            "tollPlacesType",
        ]),

        currentLocale() {
            return window.default_locale;
        },
    },

    watch: {
        markers(newValue) {
            if (Object.keys(newValue).length) {
                this.show = false;
                this.$refs.container.style.height = "auto";
            }
        },

        highwayMarkers(newValue) {
            if (Object.keys(newValue).length) {
                this.show = false;
                this.$refs.container.style.height = "auto";
            }
        },

        modal(newValue) {
            if (this.show === true && newValue && newValue.type) {
                this.show = false;
                this.$refs.container.style.height = "auto";
            }
        },

        filters(newValue) {
            if (Object.keys(newValue).length) {
                this.show = false;
                this.$refs.container.style.height = "auto";
            }
        },
    },
};
</script>
